import {createSlice} from "@reduxjs/toolkit";
import {fetchDashboardData} from "../thunks/dashBoardThunk";

const initialState = {
    loading: false,
    error: null,
    stats: null,
};


const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDashboardData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDashboardData.fulfilled, (state, action) => {
                state.loading = false;
                state.stats = action.payload;
            })
            .addCase(fetchDashboardData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default dashboardSlice.reducer;
